/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { Loader } from "@app/components/core/Loader/Loader"
import { Decoration } from "@app/components/map/Decoration"
import { Hotspot } from "@app/components/map/Hotspot"
import { LoungerGroup } from "@app/components/map/LoungerGroup"
import Button from "@app/components/move2Library/Button/Button"
import OrderContentBody from "@app/components/order/OrderContentBody/OrderContentBody"
import Page from "@app/components/pageTypes/Page/Page"
import { AddedLoungerMessage } from "@app/pages/funnel/order/LoungerMapSelection/LoungerMapSelection"
import { useRaiseError } from "@app/store/actions/errorActions"
import { selectLoungerId, setObjectGroupOptions } from "@app/store/actions/orderActions"
import { useGetLoungerTypes } from "@app/store/service/cmsService"
import {
	useDeleteObjectOption,
	useGetHotspots,
	useGetMapDecorations,
	useGetMaps,
	useGetObjects,
	useSaveObjectGroupOptions,
	useSaveObjectOptions,
} from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { getPriceString } from "@app/utils/localeUtils"
import { selectCountOfLoungerWithSelection, selectFullPrice, selectObjectGroups, selectSelectedObjectIds } from "@app/utils/selectors"
import { classNamez, useCallbackRef } from "@tecreation/funnel-components"
import { ResponseError, useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect, useRef, useState } from "react"

export default function Page2({ onNext, onBack }) {
	const price = useSelector(selectFullPrice)
	const selectedObjectIds = useSelector(selectSelectedObjectIds)
	const loungers = useSelector(state => state.order.loungers)
	const countOfLoungerWithSelection = useSelector(selectCountOfLoungerWithSelection)
	const selectedObjectGroups = useSelector(selectObjectGroups)
	const availableLoungers = useSelector(state => state.order.availableLoungers)
	const selectedDay = useSelector("order.selectedDay")
	const objectGroupOptions = useSelector(state => state.order.objectGroupOptions)

	const [addedGroup, setAddedGroup] = useState(undefined)
	const [__, forceRender] = useState({})
	const [map, setMap] = useState(null)
	const [showHotspots, setShowHotspots] = useState(true)

	const { handleRef: parentHandler, ref: parentRef } = useCallbackRef()
	const svg = useRef(null)
	const zoomLevel = useRef(1)
	const eventCache = useRef([])
	const prevPinchDiff = useRef(-1)
	const pointerStart = useRef({
		x: 0,
		y: 0,
		posX: 0,
		posY: 0,
		width: 0,
		height: 0,
	})
	const raiseError = useRaiseError()

	const { data: maps } = useGetMaps({ zoneId: appStore.get("core.zoneId") })
	const { data: hotspots } = useGetHotspots({ zoneId: appStore.get("core.zoneId") })
	const { data: objects } = useGetObjects({ zoneId: appStore.get("core.zoneId") })
	const { data: decorations } = useGetMapDecorations({ zoneId: appStore.get("core.zoneId") })
	const { data: __types } = useGetLoungerTypes({ zoneId: appStore.getState().core.zoneId })
	const [saveObjectsOptions] = useSaveObjectOptions()
	const [saveObjectGroupOptions, { isFetching: __isSavingObjectGroups }] = useSaveObjectGroupOptions()
	const [deleteReserverationForId] = useDeleteObjectOption()

	const next = useCallback(async () => {
		try {
			let rsp = await saveObjectGroupOptions({ loungers: loungers.filter(e => !e.selectedId), dateString: selectedDay.date }).unwrap()
			if (loungers.filter(e => e.selectedId).length) {
				let rsp2 = await saveObjectsOptions({ objectIds: selectedObjectIds, dateString: selectedDay.date }).unwrap()
				setObjectGroupOptions([...rsp, ...rsp2])
			} else {
				setObjectGroupOptions([...rsp])
			}

			onNext()
		} catch (e) {
			raiseError(e, undefined, true)
		}
	}, [onNext, selectedDay, loungers])

	useEffect(() => {
		const f = async function () {
			//remove reserveration on mount
			Promise.all(
				objectGroupOptions.map(object => {
					return deleteReserverationForId({ objectOptionId: object.objectOptionId }).unwrap()
				}),
			).catch(e => {
				if (e instanceof ResponseError) {
					if (e && e.response.data && e.response.data.errorMessage && e.response.data.errorMessage.startsWith("wrn.Object.OptionNotFound")) {
						return
					}
				}
				raiseError(e, undefined, true)
			})
		}
		f()
	}, [])

	useEffect(() => {
		if (maps && hotspots && objects && !map && availableLoungers) {
			let map = maps[0]

			for (let m of maps) {
				let mapId = m.mapId
				let selectMap = false
				for (let selectedGroupOption of selectedObjectGroups) {
					let objectGroup = objects.find(e => e.objectGroupId === selectedGroupOption)
					let founded = false
					if (objectGroup) {
						//search a option that is available inside the selectedGroup
						for (let option of objectGroup.objects.filter(o => o.mapId === mapId)) {
							const isAvailable = availableLoungers.find(available => available.objectIds && available.objectIds?.indexOf(option.objectId) !== -1) !== undefined
							founded = isAvailable
							//we found a options so we can break out the object loop
							if (founded) {
								break
							}
						}
					}

					//one group was not abvailable so we dont need search more inside the maps
					if (founded == false) {
						selectMap = false
						break
					} else {
						selectMap = true
					}
				}
				if (selectMap) {
					//we have a valid map we can break
					map = m
					break
				}
			}

			setMap(map || maps[0])

			forceRender({})
		}
	}, [maps, hotspots, objects, selectedObjectGroups, availableLoungers, map])

	useEffect(() => {
		if (parentRef.current && map) {
			parentRef.current.innerHTML = map.svg
			svg.current = parentRef.current.firstElementChild
			svg.current && svg.current.addEventListener("wheel", handleWheel, { passive: false })
			svg.current && svg.current.addEventListener("pointerdown", handleMapPointerDown)
			svg.current && svg.current.addEventListener("pointerup", handleMapPointerUp)
			svg.current && svg.current.addEventListener("pointerleave", handleMapPointerUp)

			forceRender({})
		}

		return () => {
			svg.current && svg.current.removeEventListener("wheel", handleWheel)
			svg.current && svg.current.removeEventListener("pointermove", handleMapPointerMove)
			svg.current && svg.current.removeEventListener("pointerdown", handleMapPointerDown)
			svg.current && svg.current.removeEventListener("pointerup", handleMapPointerUp)
			svg.current && svg.current.removeEventListener("pointerleave", handleMapPointerUp)
		}
	}, [parentRef.current, map])

	const raiseZoom = useCallback((x, y, w, h) => {
		zoomLevel.current = svg.current.getCTM().a

		svg.current.setAttributeNS(null, "viewBox", `${x} ${y} ${w} ${h}`)
		setShowHotspots(!(zoomLevel.current > 0.35))
	})

	const zoomTo = useCallback((event, coordinates) => {
		let { x, y } = coordinates
		let w, h
		let margin = 600

		let box = event.target.getBBox()
		x = x || box.x
		y = y || box.y
		let width = box.width
		let height = box.height
		;+(margin * 1 || 0)

		if (margin) {
			x = x - margin / 2
			y = y - margin / 2
			width = width + margin
			height = height + margin
		}

		// From here on we use the x and y to animate...
		let vb = svg.current.viewBox.baseVal

		let distance = {
			x: x - vb.x,
			y: y - vb.y,
			w: vb.width - width,
			h: vb.height - height,
		}

		let start = {
			x: vb.x,
			y: vb.y,
			w: vb.width,
			h: vb.height,
		}

		let duration = 400
		let starttime = null

		function animate(timestamp) {
			if (!starttime) starttime = timestamp
			let runtime = timestamp - starttime
			let progress = runtime / duration

			x = start.x + progress * distance.x
			y = start.y + progress * distance.y
			w = start.w - progress * distance.w
			h = start.h - progress * distance.h

			raiseZoom(x, y, w, h)

			if (runtime < duration) requestAnimationFrame(animate)
		}

		requestAnimationFrame(animate)
	})

	const zoom = useCallback((direction, clientX, clientY, customFactor = 1.1) => {
		let factor = customFactor
		let width, height, x, y, deltaX, deltaY
		let pt = svg.current.createSVGPoint()
		pt.x = clientX
		pt.y = clientY
		let pos = pt.matrixTransform(svg.current.getScreenCTM().inverse())

		if (direction > 0) {
			// Zoom out
			if (zoomLevel.current < 0.1) return
			width = svg.current.viewBox.baseVal.width * factor
			height = svg.current.viewBox.baseVal.height * factor
			deltaX = pos.x - svg.current.viewBox.baseVal.x
			deltaY = pos.y - svg.current.viewBox.baseVal.y
			deltaX = deltaX * factor
			deltaY = deltaY * factor
			x = pos.x - deltaX
			y = pos.y - deltaY
		} else {
			// Zoom in
			width = svg.current.viewBox.baseVal.width / factor
			height = svg.current.viewBox.baseVal.height / factor
			deltaX = pos.x - svg.current.viewBox.baseVal.x
			deltaY = pos.y - svg.current.viewBox.baseVal.y
			deltaX = deltaX / factor
			deltaY = deltaY / factor
			x = pos.x - deltaX
			y = pos.y - deltaY
		}

		raiseZoom(x, y, width, height)
	}, [])

	const handleWheel = useCallback(event => {
		event.preventDefault()
		let { deltaY, clientX, clientY } = event
		zoom(deltaY, clientX, clientY)
	}, [])

	const handleMapPointerDown = useCallback(event => {
		pointerStart.current = {}
		pointerStart.current.x = event.clientX
		pointerStart.current.y = event.clientY
		pointerStart.current.posX = svg.current.viewBox.baseVal.x
		pointerStart.current.posY = svg.current.viewBox.baseVal.y
		pointerStart.current.width = svg.current.viewBox.baseVal.width
		pointerStart.current.height = svg.current.viewBox.baseVal.height

		eventCache.current.push(event)

		svg.current.addEventListener("pointermove", handleMapPointerMove)
	}, [])

	const handleMapPointerMove = useCallback(event => {
		event.preventDefault()
		event.stopImmediatePropagation()

		if (eventCache.current.length < 2) {
			let el = svg.current
			let start = pointerStart.current

			let distanceX = event.clientX - start.x
			let distanceY = event.clientY - start.y

			let matrix = el.getCTM()
			let x = distanceX / matrix.a - start.posX
			let y = distanceY / matrix.d - start.posY

			el.setAttributeNS(null, "viewBox", `${-x} ${-y} ${start.width} ${start.height}`)
		} else {
			const index = eventCache.current.findIndex(cachedEv => cachedEv.pointerId === event.pointerId)
			eventCache.current[index] = event

			if (eventCache.current.length === 2) {
				// Calculate the distance between the two pointers
				const curDiffX = Math.abs(eventCache.current[0].clientX - eventCache.current[1].clientX)
				const curDiffY = Math.abs(eventCache.current[0].clientY - eventCache.current[1].clientY)
				const curDiff = Math.max(curDiffX, curDiffY)
				let cX = (eventCache.current[0].clientX + eventCache.current[1].clientX) / 2
				let cY = (eventCache.current[0].clientY + eventCache.current[1].clientY) / 2

				if (prevPinchDiff.current > 0) {
					if (curDiff > prevPinchDiff.current) {
						zoom(-1, cX, cY, 1.08)
					}
					if (curDiff < prevPinchDiff.current) {
						zoom(1, cX, cY, 1.08)
					}
				}

				// Cache the distance for the next move event
				prevPinchDiff.current = curDiff
			}
		}
	}, [])

	const handleMapPointerUp = useCallback(event => {
		event.stopImmediatePropagation()
		svg.current.removeEventListener("pointermove", handleMapPointerMove)
		pointerStart.current = undefined

		const index = eventCache.current.findIndex(cachedEv => cachedEv.pointerId === event.pointerId)
		eventCache.current.splice(index, 1)
		if (eventCache.current.length < 2) {
			prevPinchDiff.current = -1
		}
	}, [])

	const handleHotspotClick = useCallback((event, hotspot) => {
		setShowHotspots(false)
		zoomTo(event, hotspot)
	}, [])

	return (
		<Page className="pb-0">
			<div className="text-center f00 pt-2">
				{countOfLoungerWithSelection} von {loungers.length} Liegen gewählt.
			</div>
			<OrderContentBody className="h-100 relative of-hidden">
				{!svg.current && (
					<div className="h-100 w-100 flex flex-center">
						<Loader show={!svg.current} />
					</div>
				)}

				<div className="flex mt-2">
					{maps &&
						maps.map &&
						maps.map(smap => {
							return (
								<div
									className={
										"px-3 py-2 border color-border-primary mr-2 rounded-top-3 clickable f6" +
										classNamez({
											"color-bg-primary": smap.mapId === (map ? map.mapId : undefined),
											"color-fg-white": smap.mapId === (map ? map.mapId : undefined),
										})
									}
									style={{ marginBottom: "-3px" }}
									onClick={() => {
										setMap(smap)
										setShowHotspots(true)
									}}
									key={smap.mapId}
								>
									{smap.map}
								</div>
							)
						})}
				</div>

				<div ref={parentHandler} className="h-100 flex  of-hidden" id="divMap" />
				{svg.current && hotspots && map && (
					<>
						{hotspots
							.filter(e => e.mapId === map.mapId)
							.map(hotspot => {
								return <Hotspot map={svg.current} hotspot={hotspot} key={hotspot.hotspotId} show={showHotspots} onClick={handleHotspotClick} tags={[]} />
							})}
					</>
				)}

				{svg.current && decorations && map && (
					<>
						{decorations
							.filter(e => e.mapId === map.mapId)
							.map(decoration => {
								return <Decoration map={svg.current} decoration={decoration} key={decoration.decorationId} show={showHotspots} />
							})}
					</>
				)}

				{svg.current && objects && map && (
					<>
						{objects.map(group => {
							return (
								<LoungerGroup
									map={svg.current}
									group={group}
									key={group.objectGroupId}
									show={!showHotspots}
									selectable={selectedObjectGroups.indexOf(group.objectGroupId) !== -1}
									mapId={map.mapId}
									tags={[]}
									onLoungerSelect={(group, loungerId, objectId) => {
										if (eventCache.current.length > 1) {
											return
										}
										console.log(__types)
										group.price = availableLoungers?.find(e => e.objectGroupId == group.objectGroupId)?.price || group.price
										const added = selectLoungerId(group, objectId, __types)
										if (added) {
											let types = []
											Object.keys(__types).forEach(e => {
												types.push(...__types[e])
											})
											let cmsGroup = types.find(e => e.objectGroupId === group.objectGroupId)

											setAddedGroup({
												...cmsGroup,
												loungerId,
												...group,
												price: availableLoungers?.find(e => e.objectGroupId == group.objectGroupId)?.price || group.price,
											})
										}
									}}
								/>
							)
						})}
					</>
				)}

				<AddedLoungerMessage group={addedGroup} />
			</OrderContentBody>

			<div className="w-100 mt-auto flex flex-justify-between p-4">
				<div>
					<Button style="outlined" className="ml-4 primary" onClick={onBack}>
						Zurück
					</Button>
				</div>

				<div>
					<Button style="secondary" className="ml-4 primary" onClick={next}>
						Weiter mit {getPriceString(price)}
					</Button>
				</div>
			</div>
		</Page>
	)
}
